export default "__VITE_ASSET__Yz$kaAQC__"